<div class="subPlusSys">
    <h2 class="subTit">뷰티시장에 혁신적으로 매출을 올려줄 시스템은 없을까?</h2>
    <div class="plusCont contain">
        <dl>
            <dt data-aos="fade-right" data-aos-delay="200" data-aos-duration="800"><img
                    src="./assets/lasted/img/plus01.jpg" alt=""></dt>
            <dd data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000">
                <p>1만명 이상의 교육 컨설팅을 하면서 수많은 빅데이터들이 쌓였고, <i></i>뷰티샵 현장에서의 해결되지 않는 공통된 고민을 보았습니다.</p>
            </dd>
        </dl>
        <dl>
            <dt data-aos="fade-left" data-aos-delay="300" data-aos-duration="1000"><img
                    src="./assets/lasted/img/plus02.jpg" alt=""></dt>
            <dd data-aos="fade-right" data-aos-delay="300" data-aos-duration="800">
                <p>매출을 올리기 위해서 가장 중요한 건 객단가와 회전율 입니다.<br>
                    이를 위해서는 고객이 감동할만한 가치를 제공하는 매출증대 시스템이 있어야 합니다.</p>
            </dd>
        </dl>
        <dl>
            <dt data-aos="fade-right" data-aos-delay="200" data-aos-duration="800"><img
                    src="./assets/lasted/img/plus03.jpg" alt=""></dt>
            <dd data-aos="fade-left" data-aos-delay="200" data-aos-duration="1000">
                <p>지금까지 뷰티시장은 기술의 가치를 인정 받을 수 있는 <i></i>가격이 형성되어 있지 않아 수익의 한계가 있었습니다.</p>
            </dd>
        </dl>
        <dl class="mb-5">
            <dt data-aos="fade-left" data-aos-delay="300" data-aos-duration="1000"><img
                    src="./assets/lasted/img/plus04.jpg" alt=""></dt>
            <dd data-aos="fade-right" data-aos-delay="300" data-aos-duration="800">
                <p>이러한 고민을 해결하기 위해 탄생한 것이 '더조각 플러스 시스템' 입니다.<br>
                    오랜 시간 각 분야의 전문가들과 수많은 연구 끝에 미용인들의 가치를 인정받을수 있는 진짜 돈이 되는 시스템 '더조각 플러스 시스템' 그것이 우리의 미래 입니다.</p>
            </dd>
        </dl>
    </div>
</div>
<div class="">
    <!-- <div class="mainVisual">
        <iframe width="100%" height="100%"
        src="https://www.youtube.com/embed/rbFg_ONOk20?autoplay=1&mute=1&controls=0&loop=1&playlist=rbFg_ONOk20" title=""
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      <div class="mainVisLayer"></div>
    </div>
    <hp-slider [showMainProd]="false"></hp-slider> -->
    <hp-media></hp-media>
    <hp-notice [showMainTen]="true"></hp-notice>
    <!-- mainStore -->
    <div class="mainStore">
        <div class="contain">
            <h2 class="mainTit" data-aos="fade-down" data-aos-delay="200" data-aos-duration="800">
                <p>The jogak Plus System</p>
                더조각 플러스 시스템 도입 지점
            </h2>
            <div class="mainStoreCont" data-aos="fade-down" data-aos-delay="400" data-aos-duration="800"
                style="height: 650px;">
                <app-plus-map></app-plus-map>
            </div>
        </div>
    </div>
    <!-- //mainStore -->

    <!-- mainSeminar -->
    <div class="mainSeminar">
        <h2 class="mainTit" data-aos="fade-down" data-aos-delay="200" data-aos-duration="800">
            <p>The jogak Plus System</p>
            새로운 사업의 성공스토리를 만들어가실 <i></i>대표님들을 모십니다.
        </h2>
        <p data-aos="fade-down" data-aos-delay="300" data-aos-duration="800">
            더조각 플러스 시스템 도입 신청은 선착순이 아닙니다. <i></i>
            최대한 정보를충분히 검토하고, 신중히판단 하세요. <i></i>
            저희 시스템이 도움이 된다고 확신이 되는 분에 한해 진행해드립니다.
        </p>
        <div class="btns" data-aos="fade-down" data-aos-delay="400" data-aos-duration="800">
            <a href="https://forms.gle/yHVUoKqiZ4okFybH6" target="_blank">세미나 일정 보기 및 접수신청</a>
            <a href="https://pf.kakao.com/_xnSsxcxj/chat" target="_blank">카카오톡 문의하기</a>
        </div>
    </div>
    <!-- //mainSeminar -->
</div>